import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  block-size: 100%;
  background-color: ${cssTheme.default.day.backgroundMinor};
  border-radius: ${spacing(2)};
  cursor: pointer;
  padding: ${spacing(1)};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${cssTheme.components.buttons.default.bgColorHovered};
  }

  &:active {
    background-color: ${cssTheme.components.buttons.default.bgColorPressed};
  }
`
export const item = css`
  &:nth-child(n + 2) {
    margin-block-start: ${spacing(0.5)};
  }
`
export const radio = css`
  ${cssTheme.default.day.controlMinor.token}: transparent;
`
